// extracted by mini-css-extract-plugin
export default {"container":"Accounts_container__9u71u","flexGrid":"Accounts_flexGrid__vmqNG","sidebar":"Accounts_sidebar__NUu9e","content":"Accounts_content__+218G"};